import { TShirt, FlowerLotus, SealCheck, Sparkle } from "@phosphor-icons/react";
import { Reveal, Overline } from "@/components/Reveal";
import { useLang } from "@/i18n";

const ICONS = { TShirt, FlowerLotus, SealCheck, Sparkle };
const IMG = "https://images.pexels.com/photos/6466496/pexels-photo-6466496.jpeg?auto=compress&cs=tinysrgb&w=1400";

export default function Cleaning() {
  const { t } = useLang();
  return (
    <section id="pulizia" data-testid="cleaning-section" className="bg-ivory py-28 md:py-40">
      <div className="mx-auto grid max-w-[1400px] grid-cols-1 items-center gap-16 px-6 lg:grid-cols-2 lg:gap-20 lg:px-12">
        <Reveal className="relative order-2 lg:order-1">
          <div className="absolute -left-4 -top-4 hidden h-full w-full border border-champagne/50 lg:block" />
          <div className="group relative overflow-hidden">
            <img
              src={IMG}
              alt="Preparazione impeccabile di una camera"
              loading="lazy"
              className="aspect-[4/5] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
            />
          </div>
        </Reveal>

        <Reveal delay={0.1} className="order-1 lg:order-2">
          <Overline>{t.cleaning.overline}</Overline>
          <h2 className="font-serif text-4xl font-light leading-[1.08] tracking-tight text-navy md:text-5xl lg:text-6xl">
            {t.cleaning.title}
          </h2>
          <p className="mt-8 max-w-lg text-base font-light leading-relaxed text-navy/70 md:text-lg">
            {t.cleaning.text}
          </p>

          <div className="mt-12 grid grid-cols-1 gap-px border border-champagne/25 bg-champagne/25 sm:grid-cols-2">
            {(t.cleaning.standards || []).map((s, i) => {
              const Icon = ICONS[s.icon];
              return (
                <div key={i} data-testid={`cleaning-standard-${i + 1}`} className={`group bg-ivory p-8 transition-colors duration-500 hover:bg-navy ${i === t.cleaning.standards.length - 1 && t.cleaning.standards.length % 2 !== 0 ? "sm:col-span-2" : ""}`}>
                  <Icon size={30} weight="light" className="text-champagne" />
                  <h3 className="mt-5 font-serif text-xl font-light tracking-tight text-navy transition-colors duration-500 group-hover:text-ivory">
                    {s.title}
                  </h3>
                  <p className="mt-2 text-sm font-light leading-relaxed text-navy/60 transition-colors duration-500 group-hover:text-ivory/65">
                    {s.text}
                  </p>
                </div>
              );
            })}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
